import React from 'react';
import { Tooltip, Avatar, Box } from '@mui/material';
import { formatResponsiblePerson } from '../../services/projectService';

interface ResponsiblePersonDisplayProps {
  person: any | undefined;
  label?: string;
}

/**
 * Komponent wyświetlający inicjały osoby odpowiedzialnej z pełnym imieniem i nazwiskiem w tooltipie
 */
const ResponsiblePersonDisplay: React.FC<ResponsiblePersonDisplayProps> = ({ person, label }) => {
  // Jeśli person jest stringiem (ID użytkownika), nie wyświetlaj go - pokaż placeholder
  if (typeof person === 'string' && person.trim() !== '') {
    // Sprawdź czy to wygląda na UUID (36 znaków z myślnikami)
    const looksLikeUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(person.trim());
    if (looksLikeUUID || person.length > 20) {
      // To prawdopodobnie ID użytkownika, nie wyświetlaj go
      return (
        <Tooltip title={label ? `${label}: Brak danych` : 'Brak danych'} arrow placement="top">
          <Avatar sx={{ width: 25, height: 25, fontSize: '0.7rem' }}>–</Avatar>
        </Tooltip>
      );
    }
  }

  // Przyjmij string lub obiekt użytkownika (display_name/first_name/last_name/email)
  const full = typeof person === 'object' && person !== null
    ? (person.display_name || `${person.first_name || ''} ${person.last_name || ''}`.trim() || person.email || '')
    : '';
  const { initials, fullName } = formatResponsiblePerson(full);
  const avatarUrl = typeof person === 'object' && person !== null ? (person.avatar_url || '') : '';

  if (!fullName && !avatarUrl) {
    return (
      <Tooltip title={label ? `${label}: Brak danych` : 'Brak danych'} arrow placement="top">
        <Avatar sx={{ width: 25, height: 25, fontSize: '0.7rem' }}>–</Avatar>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={label ? `${label}: ${fullName || ''}` : (fullName || '')} arrow placement="top">
      <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
        <Avatar src={avatarUrl || undefined} alt={fullName || undefined} sx={{ width: 25, height: 25, fontSize: '0.7rem' }}>
          {initials}
        </Avatar>
      </Box>
    </Tooltip>
  );
};

export default ResponsiblePersonDisplay;
